import React, { useRef, useState, useEffect } from "react";
import { Button, Form, Modal, Table } from "react-bootstrap";
import { FaEdit, FaTrashAlt, FaEye } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import {
  deleteEmployeeById,
  toggleEmployeeStatus,
} from "../../services/axios/apiManager";
import { useAppContext } from "../../services/context";
// import EmployeeDetails from "./employeeDetails";
import { toast } from "sonner";
import BSPagination from "../../Components/pagination";
import LoadingSpinner from "../../Components/spinner";
import {
  changeFilters,
  applyFilters,
  handleSearchByName,
  fetchEmployees,
  clearFilters,
} from "./helpers";
import { handleErrors } from "../../services/dataManager";
import $ from "jquery";
import "datatables.net-bs5";
import "datatables.net-bs5/css/dataTables.bootstrap5.min.css";

const EmployeesList = ({
  employees,
  setEmployees,
  departments,
  designations,
  roles,
  pagination,
  setPagination,
  granted,
}) => {
  const { setState } = useAppContext();
  const [showOptionsModal, setShowOptionsModal] = useState(false);
  const [openDetailsModal, setOpenDetailsModal] = useState(false);
  const [filtering, setFiltering] = useState(false);
  const [modalOptions, setModalOptions] = useState({});
  const [query, setQuery] = useState("");
  const [filters, setFilters] = useState({});
  const navigate = useNavigate();
  const tableRef = useRef(null);

  const handleFilterChange = async (e) => {
    setFiltering(true);
    const filterObj = await changeFilters(e, setFilters, filters, setEmployees);
    await applyFilters(filterObj, setEmployees, pagination, setPagination);
    setFiltering(false);
  };

  const handlePageChange = async (page) => {
    const temp = { ...pagination };
    setPagination((prev) => ({ ...prev, currentPage: page }));
    temp.currentPage = page;
    await fetchEmployees(setEmployees, temp, setPagination);
  };

  // // //Delete Employee Logic
  const handleDeleteEmployee = (emp) => {
    setModalOptions({
      header: "Delete Employee",
      body: `Are you sure you want to delete employee "${emp.first_name || ""} ${emp.last_name || ""}"?`,
      okay: "Delete",
      method: deleteEmployee,
      data: { id: emp.id },
    });
    setShowOptionsModal(true);
  };

  const deleteEmployee = async (data) => {
    if (data.id) {
      const res = await deleteEmployeeById(data.id);
      if (res?.data?.success) {
        toast("Employee has been deleted!", { duration: 2000 });
        await fetchEmployees(setEmployees, pagination, setPagination);
        setModalOptions({});
        setShowOptionsModal(false);
      } else {
        handleErrors(res, navigate);
        setModalOptions({});
        setShowOptionsModal(false);
      }
    }
  };

  // // // Change Employee Status Logic
  const handleStatusChange = async (emp) => {
    if (!granted?.some((g) => g?.type === "toggle-status")) {
      toast.error(
        "You don't have neccessary permissions to do this operation!",
        { duration: 3000 }
      );
      return;
    }
    setModalOptions({
      header: "Change Status",
      body: `Are you sure you want to change the status of employee "${emp.first_name || ""} ${emp.last_name || ""}"?`,
      okay: "Change",
      method: changeStatus,
      data: { id: emp.id, status: emp.status === 1 ? 0 : 1 },
    });
    setShowOptionsModal(true);
  };

  const changeStatus = async (data) => {
    const res = await toggleEmployeeStatus(data);
    if (res?.data?.success === true) {
      await fetchEmployees(setEmployees, pagination, setPagination);
    } else {
      handleErrors(res, navigate);
    }
    setModalOptions({});
    setShowOptionsModal(false);
  };

  // Close options Modal
  const handleCloseOptionsModal = () => {
    setModalOptions({});
    setShowOptionsModal(false);
  };

  // // // Add/Edit Employee loic
  const handleAddEditEmployee = (id = null) => {
    if (id) {
      setState((prev) => ({ ...prev, employeeId: id }));
      navigate(`/AddEditEmployee/basicInfo/${id}`);
    } else {
      navigate(`/AddEditEmployee/basicInfo`);
    }
  };

  const handleNavigateUserProfile = (id) => {
    navigate(`/EmployeeProfile/${id}`);
  };

  useEffect(() => {
    const $table = $(tableRef.current);
    const rows = employees.map((emp) => {
      const statusBtn =
        `<button class="btn btn-sm status-btn ${emp.status === 1 ? "text-success" : "text-danger"}" data-id="${emp.id}" title="change status">` +
        `${emp.status === 1 ? "Active" : "Inactive"}</button>`;

      let actions = `<button class="btn btn-sm btn-outline-success view-btn me-1" data-id="${emp.id}" title="View">
           <i class=\"fas fa-eye\"></i>
         </button>`;

      if (granted.some((g) => g.type === "update")) {
        actions += `<button class="btn btn-sm btn-outline-primary edit-btn me-1" data-id="${emp.id}" title="Edit">
             <i class=\"fas fa-edit\"></i>
           </button>`;
      }
      if (granted.some((g) => g.type === "delete") && emp.status === 0) {
        actions += `<button class="btn btn-sm btn-outline-danger delete-btn" data-id="${emp.id}" title="Delete">
             <i class=\"fas fa-trash-alt\"></i>
           </button>`;
      }

      return [
        `${emp.first_name} ${emp.last_name}`,
        emp.email,
        emp.role?.name || "",
        emp.department?.name || "",
        emp.designation?.title || "",
        statusBtn,
        actions,
      ];
    });

    const config = {
      data: rows,
      columns: [
        { title: "Name" },
        { title: "Email" },
        { title: "Role" },
        { title: "Department" },
        { title: "Designation" },
        { title: "Status", orderable: false },
        { title: "Actions", orderable: false },
      ],
      destroy: true,
      responsive: true,
      paging: false,
      searching: false,
    };

    if ($.fn.dataTable.isDataTable(tableRef.current)) {
      $table.DataTable().clear().rows.add(rows).draw();
    } else {
      $table.DataTable(config);
    }

    // delegate clicks
    $table.off("click", ".view-btn").on("click", ".view-btn", function () {
      const id = $(this).data("id");
      navigate(`/EmployeeProfile/${id}`);
    });

    $table.off("click", ".edit-btn").on("click", ".edit-btn", function () {
      const id = $(this).data("id");
      setState((prev) => ({ ...prev, employeeId: id }));
      navigate(`/AddEditEmployee/basicInfo/${id}`);
    });

    $table.off("click", ".status-btn").on("click", ".status-btn", function () {
      const id = $(this).data("id");
      const emp = employees.find((e) => e.id === id);
      handleStatusChange(emp);
    });

    $table.off("click", ".delete-btn").on("click", ".delete-btn", function () {
      const id = $(this).data("id");
      const emp = employees.find((e) => e.id === id);
      handleDeleteEmployee(emp);
    });

    return () => {
      if ($.fn.dataTable.isDataTable(tableRef.current)) {
        $table.DataTable().destroy();
      }
    };
  }, [employees, granted]);

  return (
    <div className="container bg-dark rounded mb-4 py-2">
      <div className="container-fluid my-4">
        <div className="d-flex justify-content-end">
          {granted.some((g) => g.type === "create") && (
            <Button
              title="Add new employee"
              className="btn btn-success"
              onClick={() => {
                handleAddEditEmployee();
              }}
            >
              Add New Employee
            </Button>
          )}
        </div>
      </div>
      <div className="row align-items-center mb-4">
        <div className="col-md-3">
          <Form.Control
            type="text"
            placeholder="Search employees..."
            value={query}
            onChange={(e) =>
              handleSearchByName(
                e,
                setEmployees,
                setQuery,
                pagination,
                setPagination
              )
            }
            className="bg-dark text-light border-light input-placeholder-light"
          />
        </div>
        <div className="col-md-2">
          <Form.Select
            className="bg-dark text-light border-light input-placeholder-light"
            name="depId"
            value={filters?.depId || ""}
            onChange={handleFilterChange}
          >
            <option value="">All departments</option>
            {departments?.map((dep) => (
              <option key={dep.id} value={dep.id}>
                {dep.name}
              </option>
            ))}
          </Form.Select>
        </div>
        <div className="col-md-2">
          <Form.Select
            className="bg-dark text-light border-light input-placeholder-light"
            name="desId"
            value={filters?.desId || ""}
            onChange={(e) => {
              handleFilterChange(e);
            }}
          >
            <option value="">All designations</option>
            {designations?.map((des) => (
              <option key={des.id} value={des.id}>
                {des.title}
              </option>
            ))}
          </Form.Select>
        </div>
        <div className="col-md-2">
          <Form.Select
            className="bg-dark text-light border-light input-placeholder-light"
            name="roleId"
            value={filters?.roleId || ""}
            onChange={(e) => {
              handleFilterChange(e);
            }}
          >
            <option value="">All roles</option>
            {roles?.map((role) => (
              <option key={role.id} value={role.id}>
                {role.name}
              </option>
            ))}
          </Form.Select>
        </div>
        <div className="col-md-2">
          <Form.Select
            name="status"
            value={filters?.status || 3}
            onChange={(e) => {
              {
                handleFilterChange(e);
              }
            }}
            className="bg-dark border-light text-light"
          >
            <option value="3">Active & Inactive</option>
            <option value="1">Active only</option>
            <option value="0">Inactive only</option>
            <option className="text-danger" value="2">
              Deleted only
            </option>
          </Form.Select>
        </div>
        <div className="col-md-1">
          {filtering ? (
            <LoadingSpinner size={"md"} />
          ) : (
            <div className="row pr-2">
              <Button
                title="Reset filters And Rrfresh Records"
                className="btn btn-success"
                onClick={() => {
                  clearFilters(
                    filters,
                    setFilters,
                    setEmployees,
                    pagination,
                    setPagination,
                    setQuery
                  );
                }}
              >
                Reset
              </Button>
            </div>
          )}
        </div>
      </div>

      <div className="table-responsive">
        <table
          ref={tableRef}
          className="table table-dark table-striped table-hover w-100"
        />

        <div className="constainer-fluid">
          <div className="d-flex justify-content-end">
            <div className="mx-4 py-2">
              <span className="text-light">{`Rows/Page ${pagination.pageSize || 0}, Total records ${pagination?.totalRecords || 0}`}</span>
            </div>
            <BSPagination
              currentPage={pagination.currentPage}
              totalPages={pagination.totalPages}
              onPageChange={handlePageChange}
              siblingCount={2}
              showFirstLast={true}
            />
          </div>
        </div>
      </div>
      {/* /////////////////Employee Details Modal/////////////// */}
      {/* <EmployeeDetails
        openDetailsModal={openDetailsModal}
        setOpenDetailsModal={setOpenDetailsModal}
      /> */}

      {/* /////////////////Options Modal/////////////// */}
      <Modal
        show={showOptionsModal}
        onHide={handleCloseOptionsModal}
        centered
        className="text-light"
      >
        <Modal.Header closeButton className="bg-dark text-light border-0">
          <Modal.Title>{modalOptions.header}</Modal.Title>
        </Modal.Header>
        <Modal.Body className="bg-dark text-light">
          {modalOptions.body}
        </Modal.Body>
        <Modal.Footer className="bg-dark text-light border-0">
          <Button variant="secondary" onClick={handleCloseOptionsModal}>
            Cancel
          </Button>
          <Button
            variant="danger"
            onClick={() => {
              modalOptions.method(modalOptions.data);
            }}
          >
            {modalOptions.okay}
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
};
export default EmployeesList;
